// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gS","advertCardNum":"c-a_gT"};